
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MembershipSection from './components/MembershipSection';
import ProgramsSection from './components/ProgramsSection';
import PartnersSection from './components/PartnersSection';
import NewsSection from './components/NewsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <MembershipSection />
        <ProgramsSection />
        <PartnersSection />
        <NewsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
